import { parseAsBoolean, useQueryState } from 'nuqs'

export function useQuickActionsMenu() {
  const [isShowing, setIsShowing] = useQueryState(
    'isShowingQuickActionsMenu',
    parseAsBoolean.withDefault(false),
  )

  return {
    isShowing,
    toggle: () => setIsShowing((prev) => !prev),
    show: () => setIsShowing(true),
    hide: () => setIsShowing(false),
  }
}
